import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import PhonePanel, { TPhonePanelItem } from '@views/sections/PhonePanel';
import EditPhoneMenu from '@views/sections/EditPhoneMenu';
import EmptyView from '@views/sections/EmptyView';
import { CacheEditPhoneDataKey, TConfig } from '@views/modules/device/EditPhoneEntry';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import BrowserHistory from '@helpers/BrowserHistory';
import * as Cache from '@helpers/Cache';
import { TUser } from '@apis/gloabal';
import Toast from '@widgets/Toast';
import { EDeviceVersion } from '@app/types/global.d';

const MaxContactPhoneNumber = 20;

const ContactPhoneSetting = () => {
  const configRef = useRef<TConfig>();
  const params = useRef(Filter.urlParams(window.location.search));
  const deviceType = params.current.version || '1';
  const [showPopMenu, setShowPopMenu] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<number>();
  const [users, setUsers] = useState<TUser[]>([]);

  useEffect(() => {
    init();
  }, [])

  const init = async () => {
    const result = await Http.post(Api.GetContactConfig,
      { snCode: params.current.sncode, company: params.current.company }
    );

    if(result) {
      const config: TConfig = result.data || {
        company: params.current.company,
        snCode: params.current.sncode,
        isRejectCall: true,
        users: []
      };
      configRef.current = config;
      setUsers(config.users);
    }
  }

  const onClickItem = (item: TPhonePanelItem, index: number) => {
    setSelectedIndex(index);
    if (item && item.phone) {
      setShowPopMenu(true);
    }
  }

  const onDelete = async () => {
    const data = {
      snCode: params.current.sncode,
      company: params.current.company,
      isRejectCall: configRef.current.isRejectCall,
      users: [...users].filter((item, index: number) => index !== selectedIndex && !!item.phone),
    }
    const result = await Http.post( Api.PostContactConfig, data);
    if(result) {
      Toast.show({
        title: '删除成功',
        type: 'strip'
      });
      init();
    }
  }

  const onEdit = () => {
    toEditPhonePage(selectedIndex);
  }

  const toEditPhonePage = (index: number, isAdd?: boolean) => {
    const cacheEditPhoneData = {
      type: 'contactPhone',
      selectedIndex: index,
      config: {
        ...configRef.current,
        users: [...users]
      }
    };
    if (isAdd) {
      cacheEditPhoneData.config.users.push({
        uid: '',
        phone: '',
        headImageUrl: '',
        name: '',
        index: 0,
        isAdmin: false,
        userUid: '',
      });
      cacheEditPhoneData.selectedIndex = cacheEditPhoneData.config.users.length - 1;
    }
    Cache.save(CacheEditPhoneDataKey, cacheEditPhoneData);
    BrowserHistory.push(`${PUBLIC_URL}/editphoneentry?sncode=${params.current.sncode}&company=${params.current.company}`);
  }

  return (
    <div styleName="container">
      <NavBar
        title={`通话联系人(${configRef.current?.users.length || 0}/${MaxContactPhoneNumber})`}
      />

      {
        users.length === 0 &&
        <div styleName="empty" >
          <EmptyView
            type="common"
            desc={
              <>
                <div>{deviceType === EDeviceVersion.hasScreen ? '除绑定成员和SOS求助号码外，' : '除亲情号和SOS求助号码外，'}</div>
                <div>学生证只能与添加的联系人通话。</div>
              </>
            }
          />
        </div>
      }

      {
        users.length !== 0 &&
        <div styleName="wrapper">
          <div styleName="tip-text">{deviceType === EDeviceVersion.hasScreen ? '除绑定成员和SOS求助号码外，学生证只能与以下联系人通话。' : '除亲情号和SOS求助号码外，学生证只能与以下联系人通话。'}</div>
          <PhonePanel data={users} onClick={onClickItem} />
        </div>
      }

      { users.length < MaxContactPhoneNumber && <div styleName="add-btn" onClick={() => toEditPhonePage(0, true)}>添加联系人</div> }

      {
        showPopMenu ? (
          <EditPhoneMenu
            onClose={ () => setShowPopMenu(false) }
            onDelete={onDelete}
            onEdit={onEdit}
          />
        ) : null
      }
    </div>
  )
}

export default ContactPhoneSetting;
